import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UserManagementComponent } from '../user-management.component';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-user-management-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, FormsModule, CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatSelectModule, MatDividerModule],
  templateUrl: './user-management-dialog.component.html',
  styleUrl: './user-management-dialog.component.scss'
})
export class UserManagementDialogComponent {
  userForm: FormGroup;
  roles: any = ['ADMIN', 'CASE_MANAGER'];
  constructor(private readonly dialogRef: MatDialogRef<UserManagementComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private readonly fb: FormBuilder) {
    this.userForm = this.fb.group({
      firstName: ['', [Validators.required] ],
      middleName: [''],
      lastName: ['', [Validators.required] ],
      role: ['', [Validators.required] ],
      email:[' ', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,4}$")] ],
    });
    this.userForm.patchValue(this.data.content[0]);
  }
  onSubmit() {
    if(this.data.param == 'edit') {
      this.dialogRef.close({ data: this.userForm?.value, userId: this.data.content[0].userId });
    }
    else {
      this.dialogRef.close(this.userForm?.value);
    }
  }
  cancel() {
    this.dialogRef.close(false);
  }
}